 // collection faq
    let collection_faq = document.querySelector(".new-collection-faqs span")
    if (collection_faq) {
        let faqArray = collection_faq.innerHTML.split(";");
        for (let i = 0; i < faqArray.length - 1; i++) {
            let parts = faqArray[i].replace(/<br>/gi, "").split(":");
            let question = parts[0].trim();
            let answer = parts[1].trim();

            let h2Elem = document.createElement("div");
            h2Elem.className = 'new-collection-faq-question'
            h2Elem.innerHTML = question;

            let spanElem = document.createElement("div");
            spanElem.className = 'new-collection-faq-answer'
            spanElem.innerHTML = answer;

            let faqBox = document.createElement("div");
            faqBox.className = 'new-collection-faq-box'
            faqBox.appendChild(h2Elem);
            faqBox.appendChild(spanElem);
            let container = document.querySelector(".new-collection-faq-frame")
            container.appendChild(faqBox);
        }

        let questions = document.querySelectorAll(".new-collection-faq-question")
        let answers = document.querySelectorAll(".new-collection-faq-answer")
        for (var i = 0; i < questions.length; i++) {
            (function (j) {
                questions[j].onclick = function () {
                    if (questions[j].classList.contains("active")) {
                        answers[j].classList.remove("active")
                        questions[j].classList.remove("active")
                    } else {
                        questions[j].classList.add("active")
                        answers[j].classList.add("active")
                    }
                }
            })(i)
        }
    }
